import { Component, Input } from '@angular/core';
import { ToolsProvider } from '../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';

@Component({
  selector: 'comment-tag-users',
  templateUrl: 'comment-tag-users.html',
})
export class CommentTagUsersComponent {
  log = debug('app:CommentTagUsersComponent');

  @Input() taggedUsers: any[] = [];
  @Input() taggingUser: boolean = true;
  @Input() results: any = {};
  @Input() commentTextarea: any;

  constructor(public tools: ToolsProvider) {}
  ngOnInit() {}

  async findCurrentWordTyping() {
    let cursorStart = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.selectionStart'
    );

    let cursorEnd = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.selectionEnd'
    );

    // Get the content of the textarea

    let inputValue = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.value'
    );

    // Use a regular expression to extract the word at the cursor position
    let wordsArray = this.tools.taggingWords(inputValue);

    this.log('handleTagging | findCurrentWordTyping | words: ', wordsArray);
    this.log(
      'handleTagging | findCurrentWordTyping | start & end ',
      cursorStart,
      cursorEnd
    );
    // Find the word at the cursor position
    let currentWord = null;
    let skipCharacters = 0;
    if (wordsArray) {
      for (var i = 0; i < wordsArray.length; i++) {
        let wordStart = inputValue.indexOf(wordsArray[i], skipCharacters);
        let wordEnd = wordStart + wordsArray[i].length;

        skipCharacters += wordEnd - wordStart;

        this.log(
          'handleTagging | findCurrentWordTyping | word',
          wordStart,
          wordsArray[i] || 'WORD NOT FOUND',
          wordEnd
        );

        if (cursorStart >= wordStart && cursorEnd <= wordEnd) {
          currentWord = wordsArray[i];
          break;
        }
      }
    }

    this.log('handleTagging | findCurrentWordTyping | current: ', currentWord);

    return currentWord;
  }

  getFilteredPeople() {
    return this.results.people.filter(
      person =>
        !this.taggedUsers.some(taggedPerson => taggedPerson._id === person._id)
    );
  }

  async selectUser(person: any) {
    const inputValue = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.value'
    );
    const currentWord = await this.findCurrentWordTyping();
    let wordsArray = this.tools.taggingWords(inputValue);
    const currentIndex = _.indexOf(wordsArray, currentWord);
    this.log('selectUser | words', wordsArray);
    this.log('selectUser | currentIndex', currentIndex);
    this.log('selectUser | currentWord', currentWord);

    if (currentIndex >= 0) {
      wordsArray[currentIndex] = '@' + person.localUsername;

      this.commentTextarea.nativeElement.lastElementChild.children[1].value =
        wordsArray.join(' ');
    } else {
      const anchorIndex = _.indexOf(wordsArray, '@');
      if (anchorIndex) {
        wordsArray[anchorIndex] = '@' + person.localUsername;

        this.commentTextarea.nativeElement.lastElementChild.children[1].value =
          wordsArray.join(' ');
      } else {
        return;
      }
    }

    this.taggedUsers.push(person);

    this.taggingUser = false;

    _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1'
    ).focus();

    this.tools.logAnalyticsEvent(
      'trackCustom',
      'add-comment-tagged-users-selected',
      {
        username: _.get(person, 'username'),
        userId: _.get(person, '_id'),
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/comment-tag-users/comment-tag-users.ts